import React from 'react';

import List from 'component/Accommodation/Recommender/List';
import RecommenderLoader from 'component/Layout/Loader/Recommender';

import classNames from 'classnames';
import SwiperClass from 'swiper/types/swiper-class';
import { SwiperOptions } from 'swiper/types/swiper-options';

import Portal from 'utility/Bind/Portal/Portal';

import { HotelRecommendation } from 'proto/Hotel/Recommendation/Recommendation';

import styles from '../Recommender.module.scss';
import { PortalDefinition } from '../types';

interface ListWrapperProps {
    isFetching: boolean;
    hotelItemList: HotelRecommendation[];
    target: PortalDefinition;
    hotelName: string;
    onMoreClick: () => void;
    isS4RefreshTopEnabled?: boolean;
    classListObject?: {
        RecommenderWrapper?: string;
        Slide?: string;
        SliderWrapper?: string;
    };
    withHeaderLink?: boolean;
    swiperSettings?: SwiperOptions;
}

const ListWrapper = ({
    hotelItemList,
    hotelName,
    isFetching,
    isS4RefreshTopEnabled = false,
    onMoreClick,
    target,
    classListObject,
    withHeaderLink = false,
    swiperSettings,
}: ListWrapperProps) => {
    return (
        <Portal root={target.id} key={target.id}>
            <div
                className={classNames(
                    styles.Recommender,
                    classListObject?.RecommenderWrapper,
                    {
                        [styles.RecommenderTopPosition]:
                            target.position === 'top' && !isS4RefreshTopEnabled,
                        [styles.S4Refresh]:
                            isS4RefreshTopEnabled && !isFetching,
                    }
                )}
                ref={!isFetching ? target.intersectionObserver : null}
            >
                {isFetching ? (
                    <RecommenderLoader />
                ) : (
                    <List
                        renderHeadline={true}
                        hotelItems={hotelItemList}
                        hotelName={hotelName ?? ''}
                        circledNavigation={true}
                        onMoreClick={onMoreClick}
                        trackMethod={target.trackMethod}
                        swiperSettings={{
                            ...swiperSettings,
                            spaceBetween: 15,
                            pagination: false,
                            onUpdate: (swiper: SwiperClass) => {
                                swiper.navigation.update();
                            },
                        }}
                        classListObject={{
                            Slide: classListObject?.Slide,
                            SliderWrapper: classNames(
                                styles.Slider,
                                classListObject?.SliderWrapper
                            ),
                            PrevButton: styles.PrevButton,
                            NextButton: styles.NextButton,
                        }}
                        withHeaderLink={withHeaderLink}
                    />
                )}
            </div>
        </Portal>
    );
};

export default ListWrapper;
